<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="constructionContractsAssetsFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Onderhanden projecten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="constructionContractsAssetsDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over onderhanden projecten</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.constructionContractsAssetsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(2)">
          {{ this.constructionContractsAssetsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.constructionContractsAssetsFg"
                                                       [title]="'onderhanden projecten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.constructionContractsAssetsDisclosureFg"
                                                               [title]="'Informatieverschaffing over onderhanden projecten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

